skrilla.directive('marketOffers',function() {
    return {
        templateUrl: 'directives/marketOffers/marketOffers.html',
        scope: {
        },
        controller: function($scope, searchService, queryService, paginationService, cacheService, modalService){
            $scope.key = "marketOffers";
            $scope.expiredOffers = cacheService.getObjectOrElse($scope.pageKey + "1", []);

            function getActiveOffers() {
                searchService.get("markets/offers" + queryService.getQueryString({active: true})).then(function (response) {
                    $scope.currentOffers = response.data.result;
                });
            }
            getActiveOffers();

            cacheService.registerObject("getActiveMarketOffersFn", getActiveOffers);

            $scope.search = function () {
                paginationService.resetPage($scope.key);
                paginationService.pageQuery(getOffers, $scope.key);
            }

            var getOffers = function () {
                return searchService.get("markets/offers" + queryService.getQueryString({active:false}, $scope.key)).then(function (response) {
                    $scope.expiredOffers = response.data.result;
                    cacheService.registerObject($scope.key + "1", $scope.expiredOffers);
                    paginationService.setPage($scope.key, paginationService.buildPage(response));
                });
            }

            $scope.reset = function(offer){
                modalService.confirm("Are you sure you'd like to reset this offer?", function(){
                    searchService.put("markets/offers/" + offer.id + "/reset", {}, "Offer successfully reset").then(function(){
                        getActiveOffers()
                    });
                });
            }

        }
    };
});
